import React from "react";
import Menu from "./Menu";
import Footer from "./Footer2";
import Header from "./Header/index";
import './styles.css'

const Home = () => (
  <>
    <Header />
    <Menu />
    <div className="separateDiv">
      <Footer />
    </div>
  </>
);

export default Home;
